export class ServiceContainer {
    // #region Vars
    _bottle;
    _name;
    // #endregion
    // #region Constructor
    constructor(appHost, bottle, name) {
        //Vars
        const noop = () => { };
        //init
        this._bottle = bottle;
        this._name = name;
        //Create
        bottle.service(name, noop);
    }
    // #endregion
    // #region Core
    register(name, func) {
        this._bottle.factory(`${this._name}.${name}`, func);
    }
    get(name) {
        return this._bottle.container[this._name][name];
    }
}
